import { useMemo, useEffect, useState } from "react";
import classnames from "classnames";
import { useDeviceInfoQuery } from "@/hooks";
import styles from "@/styles/Card.module.scss";
export function useSliderPosition(_ref, cardRef) {
  let {
    index,
    focusIndex,
    slidesPerView,
    activeIndex
  } = _ref;
  const {
    0: focus,
    1: setFocus
  } = useState(false);
  const {
    data
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  const active = useMemo(() => {
    if (deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isMobile || deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isTablet) return false;
    return index >= activeIndex && index < activeIndex + slidesPerView;
  }, [index, activeIndex, slidesPerView, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMobile, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isTablet]);
  const feature = useMemo(() => active && index === focusIndex, [index, focusIndex, activeIndex, active]);
  const leftEdge = useMemo(() => active && index === activeIndex, [index, slidesPerView, activeIndex, active]);
  const rightEdge = useMemo(() => active && index === activeIndex + slidesPerView - 1, [index, slidesPerView, activeIndex, active]);
  useEffect(() => {
    const transitionStart = () => setFocus(true);
    const transitionEnd = () => !feature && setFocus(false);
    if (cardRef.current) {
      cardRef.current.addEventListener("transitionstart", transitionStart);
      cardRef.current.addEventListener("transitionend", transitionEnd);
    }
    return () => {
      if (cardRef.current) {
        cardRef.current.removeEventListener("transitionstart", transitionStart);
        cardRef.current.removeEventListener("transitionend", transitionEnd);
      }
    };
  }, [feature, cardRef.current]);
  const classNames = classnames(styles.container, {
    [styles.focus]: focus,
    [styles.feature]: feature,
    [styles.leftEdge]: leftEdge,
    [styles.rightEdge]: rightEdge
  });
  return {
    classNames,
    active
  };
}